// extracted by mini-css-extract-plugin
module.exports = {"page":"OverheadTypesPage_page__2Ddd7","right":"OverheadTypesPage_right__IW0d3"};